export enum WebViewPlatformType {

    IOS = "ios",
    Android = "android",
}
